import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import {
  saveContactType,
  updateContactType,
  listenContactType,
  deleteContactType,
} from "../../utils/firebasefunctions";
import { Trash2 } from "lucide-react";
import { MdEdit } from "react-icons/md";
import { useStateValue } from "../../context/StateProvider";
import EditableSelect from "../lockbox-inventory/editable-select";

const ContactType = () => {
  const [{ user }] = useStateValue();
  const [abbreviation, setAbbreviation] = useState("");
  const [type, setType] = useState("");
  const [leadSources, setLeadSources] = useState([]);
  const options = ["Seller", "Buyer", "Both"];

  const [loading, setLoading] = useState(false);
  const [isAbbreviation, setIsAbbreviation] = useState(false);
  const [isType, setIsType] = useState(false);
  const [updateitem, setupdateitem] = useState("");
  const [openDropdown, setOpenDropdown] = useState(false);
  const [selectedOption, setSelectedOption] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (abbreviation === "") {
      toast.error("Abbreviation is required");
      setIsAbbreviation(true);
      return;
    } else if (type === "") {
      toast.error("Contact type is required");
      setIsType(true);
      return;
    } else if (selectedOption === "") {
      toast.error("Please select an option");
      return;
    }

    setLoading(true);
    const userId = user.id;

    try {
      let result;

      if (updateitem === "") {
        result = await saveContactType({
          abbreviation,
          type,
          userId,
          selectedOption,
        });
      } else {
        result = await updateContactType(updateitem.id, {
          abbreviation,
          type,
          clientType: selectedOption,
        });
      }

      if (result.success) {
        if (updateitem) {
          toast.success("Contact type updated successfully!");
          setupdateitem("");
        } else {
          toast.success("Contact type saved successfully!");
        }

        setAbbreviation("");
        setType("");
        setSelectedOption("");
      } else {
        toast.error(result.error || "Failed to save lead source");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      const result = await deleteContactType(id);
      if (result.success) {
        toast.success("Contact type deleted successfully!");
      } else {
        toast.error(result.error || "Failed to delete Contact type");
      }
    } catch (err) {
      toast.error(err.message);
    } finally {
    }
  };

  const handleUpdate = async (item) => {
    setupdateitem(item);

    setAbbreviation(item.abbreviation);
    setType(item.type);
    setSelectedOption(item.clientType || "");
  };

  useEffect(() => {
    const unsubscribe = listenContactType((data) => {
      // Always render alphabetically by Abbreviation (BA, CLA, LND, …)
      const sorted = [...(data || [])].sort((a, b) =>
        (a?.abbreviation || "").localeCompare(b?.abbreviation || "", undefined, { sensitivity: "base" })
      );
      setLeadSources(sorted);
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="">
      <form onSubmit={handleSubmit}>
        <div className="flex flex-col lg:flex-row lg:justify-between gap-4">
          <div className="w-full lg:w-[49%]">
            <label className="block font-medium">Contact Abbreviation *</label>
            <input
              type="text"
              value={abbreviation}
              placeholder="Enter Contact Abbreviation"
              onChange={(e) => setAbbreviation(e.target.value)}
              className={`w-full mt-1 ${
                isAbbreviation ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
          <div className="w-full lg:w-[49%] mt-5 lg:mt-0">
            <label className="block font-medium">Contact Type *</label>
            <input
              type="text"
              value={type}
              placeholder="Enter Contact Type"
              onChange={(e) => setType(e.target.value)}
              className={`w-full mt-1 ${
                isType ? "border-2 border-red-600" : ""
              } text-sm rounded-lg bg-white px-5 py-3 text-darkColor placeholder:text-zinc-700/50`}
            />
          </div>
        </div>
        <div className="relative w-full lg:w-[49%] mt-5 lg:mt-3 ">
          <label className="block font-medium">Client Type *</label>
          <div
            onClick={() => setOpenDropdown(!openDropdown)}
            className={`w-full border-2 bg-white rounded-lg px-5 py-3 cursor-pointer ${
              selectedOption === ""
                ? "text-gray-400 border-gray-300"
                : "text-darkColor border-gray-300"
            }`}
          >
            {selectedOption || "Select Client Type"}
          </div>

          <EditableSelect
            style={{ top: "75px", left: "0px" }}
            visible={openDropdown}
            activateoutsidecontainerclick={() => setOpenDropdown(false)}
            status={options}
            onClickcorrect={(value) => {
              setSelectedOption(value);
              setOpenDropdown(false);
            }}
          />
        </div>
        <div className="flex justify-center mt-6">
          <button
            type="submit"
            className="text-base font-medium bg-themeColor shadow-md hover:bg-themeColor/90  mt-3 flex justify-center items-center text-white rounded-full py-[10px] px-20"
          >
            <span>{updateitem !== "" ? "Update" : "Submit"}</span>
            {loading && (
              <div role="status" className="pl-3">
                <svg
                  aria-hidden="true"
                  class="w-6 h-6 text-gray-200 animate-spin dark:text-white fill-indigo-600"
                  viewBox="0 0 100 101"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
                    fill="currentColor"
                  />
                  <path
                    d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
                    fill="currentFill"
                  />
                </svg>
                <span class="sr-only">Loading...</span>
              </div>
            )}
          </button>
        </div>
      </form>
      <div className="overflow-x-auto rounded-2xl border border-gray-200 shadow-sm panelScroll mt-6 bg-white">
        <h2 className="text-xl font-semibold mb-2 p-6">
          Contact Source
        </h2>
        <table className="min-w-[700px] w-full">
          <thead>
            <tr className="bg-gray-50">
              <th className=" px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Abbreviation
              </th>
              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Contact Type
              </th>
              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Client Type
              </th>
              <th className="px-4 py-3 whitespace-nowrap !font-semibold text-center uppercase text-xs tracking-wider text-gray-500">
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            {leadSources.length === 0 ? (
              <tr>
                <td
                  colSpan="6"
                  className="text-center font-semibold text-md py-10 text-gray-500"
                >
                  No contact type added yet
                </td>
              </tr>
            ) : (
              leadSources.map((item, i) => (
                <tr
                  key={i}
                  className="border-b border-gray-200 hover:bg-gray-50 transition-colors duration-200"
                >
                  <td className="px-4 py-3 font-normal text-gray-700 text-center">
                    {item.abbreviation}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-700">
                    {item.type}
                  </td>
                  <td className="px-4 py-3 text-center text-gray-700">
                    {item.clientType}
                  </td>
                  <td className="px-4 py-3 text-center">
                    <button
                      onClick={() => handleUpdate(item)}
                      className=" mr-[5px]"
                      title="Update"
                    >
                      <MdEdit
                        size={18}
                        className="text-indigo-600 hover:text-indigo-500"
                      />
                    </button>
                    <button
                      onClick={() => handleDelete(item.id)}
                      className="text-red-500 hover:text-red-700"
                      title="Delete"
                    >
                      <Trash2 size={18} />
                    </button>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactType;
